  import React from "react";
  import { Container } from "@material-ui/core";
  import portadaConnect from "../../../../src/assets/images/casos_de_exito/Ciberseguridad_caja_arequipa.jpg";
  import arquitectura_connect_Delosi from "../../../../src/assets/images/casos_de_exito/SDP-WAF-Caja-Arequipa.jpeg";
  import { makeStyles } from "@material-ui/core/styles";
  import Grid from "@material-ui/core/Grid";
  import { CabeceraPublicacion } from "../../../components/aws/casos_exito/CabeceraPublicacion";
  import { Typography } from "@material-ui/core";
  import Accordion from "@material-ui/core/Accordion";
  import AccordionSummary from "@material-ui/core/AccordionSummary";
  import AccordionDetails from "@material-ui/core/AccordionDetails";
  import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
  import { Button } from "@material-ui/core";

  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      marginTop: "50px",
    },
    heading: {
      fontSize: "17px",
      fontWeight: "bold",
    },
  }));

  export const CasoWAF = () => {
    const classes = useStyles();
    return (
      <div>
        <div
          style={{
            paddingTop: "60px",
            backgroundColor: "var(--plomo-oscuro)",
            paddingBottom: "30px",
          }}
        >
          <Container>
            <Grid container direction="row" justifyContent="center">
              <Grid item sm={9} xs={12} style={{ padding: "60px 30px" }}>
                <CabeceraPublicacion
                  img={portadaConnect}
                  titulo="Mitiga vulnerabilidades OWASP en WordPress con AWS WAF"
                  contenido="Martes, 20 de Mayo del 2025"
                />
                <div>
                  <p
                    className="font-raleway"
                    style={{
                      backgroundColor: "#232F3E",
                      color: "white",
                      marginTop: "15px",
                      padding: "5px",
                      fontDisplay:"auto",
                    }}
                  >
                    Resumen ejecutivo
                  </p>
                  <p style={{ fontDisplay:"auto", textAlign: "justify" }}>
                      Nuestro cliente, un líder en el sector bancario, tenia como objetivo asegurar un servicio web clave para sus transacciones. En linea con ese objetivo, MANANTIAL propuso la de implementación de WAF para la protección dicho servicio web basado en WordPress. Esta solución fue desplegada
                      basada en las buenas prácticas de arquitectura considerando la exposición del servicio
                      mediante un balanceador de aplicaciones y el esquema privado del servidor.
                  </p>

                  <p
                    className="font-raleway"
                    style={{
                      backgroundColor: "#232F3E",
                      color: "white",
                      marginTop: "15px",
                      padding: "5px",
                    }}
                  >
                    Desafío del cliente
                  </p>
                  <p style={{fontDisplay:"auto", textAlign: "justify" }}> 
                    Según estimaciones del equipo interno de cliente, el sitio web esperaba recibir un gran número de invocaciones al mes. Se
                    esperaba que esta cantidad aumentara aproximadamente un 10% con la publicación
                    del servicio y el mantenimiento del servicio web. Asimismo, debido a las caracteristicas de la herramienta empleada del lado del cliente para el desarrollo de la web era necesario para protegerla de diversos ataques como SQL Injection, DDoS y explotación de vulnerabilidades.
                  </p>

                  <p
                    className="font-raleway"
                    style={{
                      backgroundColor: "#232F3E",
                      color: "white",
                      marginTop: "15px",
                      padding: "5px",
                    }}
                  >
                    ¿Por qué AWS?
                  </p>
                  <p style={{ fontDisplay:"auto", textAlign: "justify" }}>
                  Se decide usar AWS por los beneficios de los servicios que ofrece por ejemplo alta disponibilidad, infraestructura global, servicios completamente administrados por AWS, y tolerancia a fallos. Estas fueron algunos de los puntos claves considerados para decidir usar AWS, así como también la mejora asegurada de la calidad de su servicio, principalmente porque nuestro cliente logro proteger su plataforma mediante reglas con el servicio de WAF lo que optimizó el desempeño del servicio al tiempo que mantiene protegidos los vectores de riesgo identificados y garantiza una cobertura eficiente de seguridad. 
                  </p>

                  <p
                    className="font-raleway"
                    style={{
                      backgroundColor: "#232F3E",
                      color: "white",
                      marginTop: "15px",
                      padding: "5px",
                    }}
                  >
                    Socio
                  </p>
                  <p style={{fontDisplay:"auto", textAlign: "justify" }}>
                    Manantial Tecnológico es elegido mediante un proceso concursal por la amplia experiencia y certificación brindando soluciones TI, de manera ágil, eficiente y creativa, por su conocida apuesta por soluciones innovadoras demostrando potencial, calidad y compromiso en sus servicios, siendo la seguridad el pilar más importante en toda implementación propuesta y ejecutada. 
                    <br/>
                    Con amplia experiencia en servicios de seguridad en la nube de AWS, a la vanguardia de herramientas, lineamientos y buenas prácticas, MANANTIAL se posiciona como un aliado estratégico clave para organizaciones que buscan robustecer su infraestructura tecnológica, garantizando la confidencialidad, integridad y disponibilidad de su información.
                  </p>

                  <p
                    className="font-raleway"
                    style={{
                      backgroundColor: "#232F3E",
                      color: "white",
                      marginTop: "15px",
                      padding: "5px",
                    }}
                  >
                    Solución del socio
                  </p>

                  <p style={{ fontDisplay:"auto", textAlign: "justify" }}>
                    La implementación fue segmentada en 4 niveles cruciales, partiendo por alojamiento de aplicaciones, análisis, alta disponibilidad y Tolerancia a fallos, y seguridad:
                    <div className={classes.root}>
                      <Accordion style={{ backgroundColor: "#E5E5E5", marginBottom: "20px" }}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                        >
                          <Typography className={classes.heading}>
                            Alojamiento de aplicaciones
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                          Nuestra solución se encuentra alojada en un EC2 deplegada en la subnet
                          privada de nuestra VPC, este servidor cuenta con las características necesarias
                          para alojar el servicio de Wordpress y se publica hacia internet haciendo uso de
                          un Application Load Balancer. Para almacenar y gestionar archivos estáticos
                          como imágenes, videos o documentos, utilizamos Amazon S3.                          
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion style={{ backgroundColor: "#E5E5E5", marginBottom: "20px" }}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                        >
                          <Typography className={classes.heading}>
                            Análisis
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                          Usamos CloudWatch para monitorear y gestionar recursos en tiempo real,
                          permitiéndonos recolectar métricas y logs de las automatizaciones. Con
                          CloudWatch Dashboards creamos paneles personalizados para visualizar
                          métricas como “TunnelState”, “TunnelDataIn”, “TunnelDataOut”,
                          “AllowedRequests”, “BlockedRequests” y otras métricas de manera clara y
                          accesible. Para analizar grandes volúmenes de datos almacenados en S3
                          provenientes de los logs de cloudwatch de manera eficiente utilizamos Athena,
                          que nos permite ejecutar consultas SQL directamente sobre los registros.
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion style={{ backgroundColor: "#E5E5E5", marginBottom: "20px" }}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                        >
                          <Typography className={classes.heading}>
                            Alta disponibilidad y Tolerancia a fallos
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                          La arquitectura está diseñada para garantizar alta disponibilidad y tolerancia a
                          fallos, el Application Load Balancer reparte el tráfico en al menos dos subredes
                          públicas en diferentes AZ, apuntando a un Auto Scaling Group de EC2 en
                          subredes privadas; así, si una AZ falla, las instancias de la otra siguen
                          atendiendo. Los health checks del ALB retiran automáticamente las instancias
                          que no responden y Auto Scaling ajusta la capacidad según CPU/latencia. Los
                          recursos estáticos van a S3 y se hacen snapshots periódicos de EBS y backups
                          de base de datos para recuperación rápida. Además, Route 53 con health
                          checks DNS puede redirigir a un endpoint de respaldo en otra región en caso de
                          fallo total.
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion style={{ backgroundColor: "#E5E5E5", marginBottom: "20px" }}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                        >
                          <Typography className={classes.heading}>
                            Seguridad
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                          Consideramos el servicio de WAF (Web Application Firewall) dado que nos
                          ayuda a filtrar y monitorear el tráfico web para proteger la interfaz de la agente
                          personalizada contra ataques maliciosos. KMS (Key Management Service)
                          gestiona y protege el acceso a nuestras claves de cifrado, asegurando que solo
                          usuarios autorizados puedan acceder a datos sensibles. Finalmente, Shield
                          Standard nos protege contra ataques DDoS mediante la detección automática y
                          mitigación de tráfico malicioso a nivel de red y transporte, asegurando la alta
                          disponibilidad de nuestro servicio web y reduciendo el riesgo de interrupciones.
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </p>
                  <img alt="arquitectura Cloud"
                    src={arquitectura_connect_Delosi}
                    style={{
                      width: "100%",
                      marginTop: "15px",
                      marginBottom: "15px",
                    }}
                  ></img>
                  <p
                    className="font-raleway"
                    style={{
                      backgroundColor: "#232F3E",
                      color: "white",
                      marginTop: "15px",
                      padding: "5px",
                    }}
                  >
                    Resultado
                  </p>
                  <p style={{ fontDisplay:"auto", textAlign: "justify" }}>
                  Nuestro cliente mantiene la firme convicción de evolucionar junto al mercado, donde la seguridad digital es prioritaria. Los consumidores y las empresas exigen no solo funcionalidad, sino protección robusta frente a amenazas que evolucionan constantemente.
                    <br/>
                    En este contexto, la implementación de este proyecto generó los siguientes resultados:             
                    <ul>
                      <li>
                        98 % de bloqueo de ataques web maliciosos y 100 % de mitigación de picos DDoS, impidiendo intrusiones y garantizando disponibilidad continua de la plataforma. 
                      </li>
                      <li>
                        100 % de cumplimiento de políticas internas de seguridad, asegurando alineamiento total con normativas y estándares corporativos.
                      </li>
                      <li>
                        Generación automatizada de reportes de seguridad en tiempo real, optimizando un 60% el tiempo de análisis y respaldando decisiones estratégicas ante incidentes.
                      </li>
                    </ul> 
                    Estos resultados se han traducido en una plataforma más segura y eficiente, fortaleciendo la confianza de los usuarios. El cliente lo resume así: "transformamos la seguridad en un acelerador de crecimiento: un entorno protegido con visibilidad completa y procesos automatizados no solo neutraliza amenazas, sino que impulsa nuestra operación sin límites. 
                    </p> 


                </div>
              </Grid>
            </Grid>
          </Container>
        </div>
      </div>
    );
  };
